<template lang="pug">
  div(
    v-bind="wrapperConfig"
  )
    v-card(
      v-bind="cardConfig"
    ).cc-card.fill-height
      v-avatar(
        :color="avatarConfig.text || value.avatar && !value.avatar.isIcon ? undefined : 'secondary'"
        v-bind="avatarConfig"
      ).ml-8.avatar
        .avatar-overlay(
          v-if="!readonly"
          @click="pickAvatar"
        )
          v-icon(
            large
          ) mdi-camera
        v-img(
          v-if="value.avatar && !value.avatar.isIcon"
          :src="value.avatar.value.url || require('@/assets/bg-course.svg?inline')"
        )
        v-icon(
          v-else
          :size="avatarConfig.size - 100 / avatarConfig.size * 30"
          :color="avatarConfig.text ? 'secondary' : 'white'"
        ) {{ value.avatar ? value.avatar.value : defaultIcon }}
      v-card-text(
        v-bind="textBlockConfig"
      ).px-8
        C-input(
          :value="value.title"
          :readonly="readonly"
          placeholder="Заголовок"
          @input="updateByKey('title', $event)"
        ).font-weight-bold.fill-width.d-block
        C-input(
          :value="value.description"
          :readonly="readonly"
          placeholder="Добавьте описание, если необходимо..."
          @input="updateByKey('description', $event)"
        ).grey--text.mt-2
      template(v-if="!readonly")
        v-btn(
          color="secondary"
          fab
          depressed
          small
          v-bind="beforeBtnConfig"
          @click="$emit('add:before')"
        )
          .font-weight-bold +
        v-btn(
          color="secondary"
          fab
          depressed
          small
          v-bind="afterBtnConfig"
          @click="$emit('add:after')"
        )
          .font-weight-bold +
        v-btn(
          color="error darken-1"
          depressed
          small
          fab
          @click="$emit('remove')"
        ).cc-card--remove
          v-icon mdi-delete-outline
</template>

<script>
import ConstructorCard from '@/models/list/ConstructorCard';

import CInput from './CInput.vue';
import { CARD_TYPES } from './constants';

export default {
  components: {
    CInput,
  },
  props: {
    value: {
      type: Object,
      default: () => new ConstructorCard(),
    },
    type: { type: Number, default: CARD_TYPES.topAvatarShadow },
    last: { type: Boolean, default: false },
    readonly: { type: Boolean, default: false },
  },
  computed: {
    defaultIcon() {
      if (this.type === CARD_TYPES.question) return 'mdi-help';
      return 'mdi-account-school';
    },
    wrapperConfig() {
      const CONFIG = {
        [CARD_TYPES.topAvatarShadow]: {
          class: 'pt-13 fill-height',
        },
        [CARD_TYPES.leftAvatar]: {},
        [CARD_TYPES.question]: {},
        [CARD_TYPES.progress]: {
          class: 'fill-height',
        },
      };
      return CONFIG[this.type];
    },
    textBlockConfig() {
      const CONFIG = {
        [CARD_TYPES.topAvatarShadow]: { class: 'pt-0 pb-4 mt-n5' },
        [CARD_TYPES.leftAvatar]: { class: 'mr-lg-10' },
        [CARD_TYPES.question]: {},
        [CARD_TYPES.progress]: {},
      };
      return CONFIG[this.type];
    },
    avatarConfig() {
      const CONFIG = {
        [CARD_TYPES.topAvatarShadow]: {
          size: 100,
          class: 'mb-13 mt-n13',
        },
        [CARD_TYPES.leftAvatar]: { size: 100 },
        [CARD_TYPES.question]: { text: true, size: 100 },
        [CARD_TYPES.progress]: { size: 80, class: !this.last && 'cc-card--progress-dots' },
      };
      return CONFIG[this.type];
    },
    cardConfig() {
      const CONFIG = {
        [CARD_TYPES.topAvatarShadow]: { class: 'sdo-shadow sdo-radius' },
        [CARD_TYPES.leftAvatar]: {
          flat: true,
          class: 'd-flex grey lighten-5 py-5',
        },
        [CARD_TYPES.question]: { class: 'd-flex sdo-shadow sdo-radius py-4' },
        [CARD_TYPES.progress]: {
          flat: true,
          color: 'transparent',
        },
      };
      return CONFIG[this.type];
    },
    beforeBtnConfig() {
      const CONFIG = {
        [CARD_TYPES.topAvatarShadow]: { class: 'cc-card--left-plus' },
        [CARD_TYPES.leftAvatar]: { class: 'cc-card--top-plus' },
        [CARD_TYPES.question]: { class: 'cc-card--top-plus' },
        [CARD_TYPES.progress]: { class: 'cc-card--left-plus' },
      };
      return CONFIG[this.type];
    },
    afterBtnConfig() {
      const CONFIG = {
        [CARD_TYPES.topAvatarShadow]: { class: 'cc-card--right-plus' },
        [CARD_TYPES.leftAvatar]: { class: 'cc-card--bottom-plus' },
        [CARD_TYPES.question]: { class: 'cc-card--bottom-plus' },
        [CARD_TYPES.progress]: { class: 'cc-card--right-plus' },
      };
      return CONFIG[this.type];
    },
  },
  methods: {
    pickAvatar() {
      this.$modals.show('pick-avatar', {
        input: (avatar) => {
          this.updateByKey('avatar', avatar);
        },
      });
    },
    updateByKey(key, value) {
      this.$emit('input', {
        ...this.value,
        [key]: value,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
$avatar-size: 100%;

.avatar-overlay {
  cursor: pointer;
  width: 100%;
  height: 100%;
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: white;
  border-radius: 50%;
  z-index: 5;

  opacity: 0;
  transition: opacity 0.3s;

  &.loading {
    opacity: 1;
  }
}

.avatar {
  width: $avatar-size;
  height: $avatar-size;
  border-radius: 50%;

  &:hover {
    .avatar-overlay {
      opacity: 1;
    }
  }

  &__edit-button {
    top: $avatar-size / 1.4;
    left: $avatar-size / 1.4;
    border-radius: 50%;
    position: absolute;
  }
}

.cc-card {
  position: relative;

  &--progress-dots {
    position: relative;
    overflow: initial;

    &::after {
      content: '\2B24\2B24\2B24\2B24\2B24';
      letter-spacing: 20px;
      font-weight: 900;
      font-size: 8px;
      position: absolute;
      color: rgba($secondary-color, .6);
      left: calc(100% + 50px);
    }
  }

  &--remove {
    position: absolute;
    bottom: -18px;
    right: -22px;
    opacity: 0;
  }

  &--left-plus,
  &--right-plus,
  &--bottom-plus,
  &--top-plus {
    position: absolute;
    font-size: 25px;
    padding: 5px;
    opacity: 0;
  }
  &--top-plus {
    left: 50%;
    top: -20px;
  }
  &--bottom-plus {
    left: 50%;
    bottom: -20px;
  }
  &--left-plus {
    left: -22px;
    top: 40%;
  }
  &--right-plus {
    right: -22px;
    top: 40%;
  }

  &:hover {
    .cc-card--left-plus,
    .cc-card--right-plus,
    .cc-card--top-plus,
    .cc-card--bottom-plus {
      opacity: 1;
      transition: all .2s;
    }
    .cc-card--remove {
      opacity: .5;
      transition: all .2s;

      &:hover {
        opacity: 1;
      }
    }
  }
}
</style>
